import { ofType } from 'redux-observable';
import { ignoreElements } from 'rxjs/operators/ignoreElements';
import { switchMap } from 'rxjs/operators/switchMap';
import { tap } from 'rxjs/operators/tap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions } from '../../reducers/actions';
import { TagService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.CSV_HISTORY),
    switchMap(action =>
      TagService.downloadCSVHistory(
        action.tags,
        action.startDate,
        action.endDate,
        store
      ).pipe(
        tap(data => {
          const blob = new Blob([data], { type: 'octet/stream' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style = 'display: none';
          a.href = url;
          a.download = 'history.csv';
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }),
        ignoreElements(),
        catchError(retryAuthentication(action$, 'epics/tags/downloadCSVHistory'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/tags/downloadCSVHistory.js